import st from "lib/utils/index";
import BaseDecorator from "./BaseDecorator";

@BaseDecorator.translates(["location_name", "additional_instructions"])
export default class ProductPickupPointDecorator extends BaseDecorator {
  static build(data = {}) {
    return new this({
      uuid: st.generateUuid(),
      location_lat: null,
      location_lng: null,
      departure_time: null,
      arrival_time: null,
      additional_fee: null,
      position: 1,
      translations: [],
      ...data,
    });
  }

  transformData(data) {
    return super.transformData({
      ...data,
      additional_fee: data.additional_fee || null,
    });
  }
}



// WEBPACK FOOTER //
// ./src/lib/decorators/ProductPickupPointDecorator.js